import FormattedMessage from 'I18n/components/FormattedMessage';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Button } from 'foundations-components/transitional/components/Button';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
function RecipientFieldExpandLabel({
  recipientKey
}) {
  switch (recipientKey) {
    case 'cc':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.metadata-editor.recipient-field-expand-button.label.cc"
      });
    case 'bcc':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.metadata-editor.recipient-field-expand-button.label.bcc"
      });
    case 'to':
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.metadata-editor.recipient-field-expand-button.label.to"
      });
  }
}
RecipientFieldExpandLabel.displayName = 'RecipientFieldExpandLabel';
const RecipientFieldExpandButton = ({
  recipientKey,
  index,
  recipientFieldsExpansionState,
  setRecipientFieldsExpansionState,
  showCCBCCIconButtons
}) => {
  const onClickHandler = () => {
    setRecipientFieldsExpansionState(oldExpansionState => {
      return oldExpansionState.slice(0, index).concat(true).concat(oldExpansionState.slice(index + 1)).toList();
    });
  };
  const shouldRenderIcon = !recipientFieldsExpansionState.get(index) && showCCBCCIconButtons;
  return shouldRenderIcon ? /*#__PURE__*/_jsx(Button, {
    onClick: onClickHandler,
    use: "link",
    "data-selenium-test": `show-${recipientKey}-button`,
    marginInlineStart: "100",
    marginBlockStart: "0",
    children: /*#__PURE__*/_jsx(RecipientFieldExpandLabel, {
      recipientKey: recipientKey
    })
  }) : null;
};
RecipientFieldExpandButton.propTypes = {
  index: PropTypes.number.isRequired,
  recipientFieldsExpansionState: ImmutablePropTypes.list.isRequired,
  recipientKey: PropTypes.string.isRequired,
  setRecipientFieldsExpansionState: PropTypes.func.isRequired
};
RecipientFieldExpandButton.displayName = 'RecipientFieldExpandButton';
export default RecipientFieldExpandButton;